import React, { useState, useEffect } from "react";

// Graceful image loading — won't break if logo not yet placed
let Logo;
try {
  Logo = require("../images/dtg-logo.png");
} catch (e) {
  Logo = null;
}

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // IntersectionObserver for active section highlighting
  useEffect(() => {
    const sections = ["home", "puppel-show", "about", "contact"];
    const observers = [];

    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setActiveSection(id);
          }
        },
        { threshold: 0.4 }
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((obs) => obs.disconnect());
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navItems = [
    { id: "home", label: "Home" },
    { id: "puppel-show", label: "Puppel Show" },
    { id: "about", label: "About Us" },
    { id: "contact", label: "Contact" },
  ];

  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}`}>
      {Logo ? (
        <img
          src={Logo}
          alt="Doin' Together Games"
          className="navbar__logo"
          onClick={() => scrollToSection("home")}
        />
      ) : (
        <span
          className="navbar__logo-text"
          onClick={() => scrollToSection("home")}
          style={{
            fontFamily: "var(--font-heading)",
            fontSize: "1.2rem",
            color: "var(--text-accent)",
            cursor: "pointer",
            textShadow: "0 2px 8px rgba(247, 128, 65, 0.3)",
          }}
        >
          DTG
        </span>
      )}
      <div className="navbar__links">
        {navItems.map((item) => (
          <button
            key={item.id}
            className={`navbar__link${activeSection === item.id ? " active" : ""}`}
            onClick={() => scrollToSection(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
